import { BASE_URL } from "./config";

// ✅ Submit B2B enquiry
export const submitB2BEnquiry = async (payload) => {
  try {
    const res = await fetch(`${BASE_URL}/enquiry/b2b-quota`, {
      method: "POST",
      mode: "cors", // 👈 add this
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Something went wrong");
    }

    return data;
  } catch (err) {
    console.error("Error submitting enquiry:", err);
    throw err;
  }
};

// ✅ Submit Enquiry Form
export const submitEnquiryForm = async (payload) => {
  try {
    const res = await fetch(`${BASE_URL}/enquiry/form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Failed to submit enquiry");
    }

    return data;
  } catch (err) {
    console.error("Enquiry API error:", err);
    throw err;
  }
};